import(/* webpackMode: "eager" */ "/vercel/path0/src/app/github/page.tsx");
